import { PAYMENT_FREQUENCIES } from 'constants/digitalLoan';

// TODO: Replace mocks (Digital Loan amount)
export const REQUESTED_AMOUNT_CONFIG = Object.freeze({
  min: 5000,
  max: 25000,
  initial: 5000,
  step: 100,
});

export const PAYMENT_TERM_OPTIONS = Object.freeze({
  [PAYMENT_FREQUENCIES.BIWEEKLY]: [6, 13, 20, 26, 32, 39],
  [PAYMENT_FREQUENCIES.MONTHLY]: [3, 6, 9, 12, 15, 18],
});

export const PAYMENT_TERM_RANGES = Object.freeze({
  [PAYMENT_FREQUENCIES.BIWEEKLY]: {
    options: PAYMENT_TERM_OPTIONS[PAYMENT_FREQUENCIES.BIWEEKLY],
    initial: PAYMENT_TERM_OPTIONS[PAYMENT_FREQUENCIES.BIWEEKLY][0],
    unitKey: 'biweekly',
  },
  [PAYMENT_FREQUENCIES.MONTHLY]: {
    options: PAYMENT_TERM_OPTIONS[PAYMENT_FREQUENCIES.MONTHLY],
    initial: PAYMENT_TERM_OPTIONS[PAYMENT_FREQUENCIES.MONTHLY][0],
    unitKey: 'monthly',
  },
});

// TODO: monthly-income configuration
export const MONTHLY_INCOME_CONFIG = Object.freeze({
  min: 3000,
  max: 150000,
  initial: 3000,
  step: 1000,
});

/** RFC persona física con homoclave (13 posiciones). */
export const RFC_FULL_MAX_LENGTH = 13;

export const YEARS_AT_ADDRESS_OPTIONS = Object.freeze([
  { value: 'less_than_1', labelKey: 'lessThan1' },
  { value: '1_3', labelKey: 'oneToThree' },
  { value: '4_6', labelKey: 'fourToSix' },
  { value: '7_9', labelKey: 'sevenToNine' },
  { value: '9_10', labelKey: 'nineToTen' },
  { value: '10_or_more', labelKey: 'tenOrMore' },
]);

/**
 * Texto exacto que back espera en QuestionnaireRequestDTO.yearsAtAddress. */
export const YEARS_AT_ADDRESS_API_LABELS = Object.freeze({
  less_than_1: 'Menos de 1 año',
  '1_3': '1 a 3 años',
  '4_6': '4 a 6 años',
  '7_9': '7 a 9 años',
  '9_10': '9 a 10 años',
  '10_or_more': '10 o mas',
});

export function mapYearsAtAddressForApi(bucketValue) {
  return YEARS_AT_ADDRESS_API_LABELS[bucketValue] || null;
}

export const CURP_MAX_LENGTH = 18;
